export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_4c4907318f9f5af6fe67b7b5